import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Switch } from "~/components/switch";

import type { FormState } from "./form-state";

export interface WidgetConnectNullsProps {
	className?: string;
	name: string;
	connectNulls: FormState;
}

export const WidgetConnectNulls: React.FC<WidgetConnectNullsProps> = ({ className, name, connectNulls }) => {
	const monitor = useMonitor();

	return (
		<Switch
			checked={connectNulls.getInput(monitor)}
			className={className}
			name={name}
			onCheckedChange={(show) => connectNulls.setInput(show)}
		/>
	);
};
